abstract class StorageBase {
	/**
	 * @name createObject
	 * @summary Create a json object like a string in a session|local storage
	 * @param key - String for set object storage
	 * @param value - Json Object
	 * @param typeStorage - DOM Storage like sessionStorage|localStorage
	 * @return boolean - Return a boolean state if it storage record could created or not
	 */
	createObject(key: string, value: Record<string, any>, typeStorage: Storage): boolean {
		typeStorage.setItem(key, JSON.stringify(value));
		return this.getData(key, typeStorage) != null;
	}

	/**
	 * @name getObject
	 * @summary Get a json object from session|local storage
	 * @param key - String for find object storage
	 * @param typeStorage - DOM Storage like sessionStorage|localStorage
	 * @return Record<string,any>|null - return JsonObject or null if object not exist
	 */
	getObject(key: string, typeStorage: Storage): Record<string, any> | null {
		const response = this.getData(key, typeStorage);
		return response != null ? JSON.parse(response) : null;
	}

	deleteObjectAttribute(key: string, keyAttribute: string, typeStorage: Storage): boolean {
		const dataRecovered = this.getData(key, typeStorage);
		if (dataRecovered) {
			const dataRecoveredJson = JSON.parse(dataRecovered) as Record<string, any>;
			delete dataRecoveredJson[keyAttribute];
			this.createObject(key, dataRecoveredJson, sessionStorage);
			return this.getData(key, typeStorage) === null ? true : false;
		} else {
			return false;
		}
	}

	/**
	 * @name deleteByKey
	 * @summary Delete record of session|local storage by key
	 * @param key - String for find record storage to delete
	 * @param typeStorage - DOM Storage like sessionStorage|localStorage
	 * @return boolean - Return a boolean state if it storage record could deleted or not
	 */
	deleteByKey(key: string, typeStorage: Storage): boolean {
		typeStorage.removeItem(key);
		return this.getData(key, typeStorage) != null;
	}

	/**
	 * @name getAllKeys
	 * @summary Obtain all keys from session|local storage
	 * @param typeStorage - DOM Storage like sessionStorage|localStorage
	 * @return string[] - Return string array of keys
	 */
	getAllKeys(typeStorage: Storage): string[] {
		return Object.keys(typeStorage);
	}

	/**
	 * @name getData
	 * @summary Obtain a record from session|local storage by key
	 * @param key - String for find the record storage
	 * @param typeStorage - DOM Storage like sessionStorage|localStorage
	 * @return string|null - Return record storage, could be string or null if not exist
	 */
	getData(key: string, typeStorage: Storage): string | null {
		return typeStorage.getItem(key);
	}

	/**
	 * @name updateData
	 * @summary Update value for existent key in a session|local storage
	 * @param key - String for find the record storage to update
	 * @param value - String value to update
	 * @param typeStorage - DOM Storage like sessionStorage|localStorage
	 * @return boolean - Return a boolean state if it storage record could updated or not
	 */
	updateData(key: string, value: any, typeStorage: Storage): boolean {
		if (this.getData(key, typeStorage) != null) {
			typeStorage.setItem(key, value);
			return this.getData(key, typeStorage) != null;
		} else {
			return false;
		}
	}

	/**
	 * @name createData
	 * @summary Create simple data in a session|local storage
	 * @param key - String for set simple data
	 * @param value - String value to create
	 * @param typeStorage - DOM Storage like sessionStorage|localStorage
	 * @return boolean - Return a boolean state if it storage record could created or not
	 */
	createData(key: string, value: any, typeStorage: Storage): boolean {
		typeStorage.setItem(key, value);
		return this.getData(key, typeStorage) != null;
	}
}

export { StorageBase };
